/**
 * @generated SignedSource<<0479eb9dfb20db2e29e5a66a093e119c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InvoiceDetails_project$data = {
  readonly budgetType: BUDGET_TYPE | null;
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceDetailsTable_project">;
  readonly " $fragmentType": "InvoiceDetails_project";
};
export type InvoiceDetails_project$key = {
  readonly " $data"?: InvoiceDetails_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceDetails_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceDetails_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceDetailsTable_project"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "b3091e392030c9087468d1277ed3272c";

export default node;
